/**
 * Feature flags dos módulos do SIGI.
 * Lidas de variáveis de ambiente VITE_* (Vite expõe apenas as que começam com VITE_).
 *
 * Para desabilitar um módulo, defina no .env.local:
 *   VITE_MODULE_EPI_ENABLED=false
 */
export const MODULES = {
  agendamento: import.meta.env.VITE_MODULE_AGENDAMENTO_ENABLED !== "false",
  inspecao: import.meta.env.VITE_MODULE_INSPECAO_ENABLED !== "false",
  checklist: import.meta.env.VITE_MODULE_CHECKLIST_ENABLED !== "false",
  epi: import.meta.env.VITE_MODULE_EPI_ENABLED !== "false",
  pbdoc: import.meta.env.VITE_MODULE_PBDOC_ENABLED !== "false",
  seguir: import.meta.env.VITE_MODULE_SEGUIR_ENABLED !== "false",
  cadastro: import.meta.env.VITE_MODULE_CADASTRO_ENABLED !== "false",
  almoxarifado: import.meta.env.VITE_MODULE_ALMOXARIFADO_ENABLED !== "false",
  incidente: import.meta.env.VITE_MODULE_INCIDENTE_ENABLED !== "false",
  rh: import.meta.env.VITE_MODULE_RH_ENABLED !== "false",
  forms: import.meta.env.VITE_MODULE_FORMS_ENABLED !== "false",
  admin: import.meta.env.VITE_MODULE_ADMIN_ENABLED !== "false",
} as const

export type ModuleName = keyof typeof MODULES

/** Verifica se um módulo está habilitado. */
export function isModuleEnabled(name: ModuleName): boolean {
  return MODULES[name] ?? false
}
